var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCheckmark = function SvgCheckmark(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "#3685FE",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 16.1C18.4 16.71 18.1577 17.295 17.7263 17.7263C17.295 18.1577 16.71 18.4 16.1 18.4H2.3C1.0235 18.4 0 17.365 0 16.1V2.3C0 1.0235 1.0235 0 2.3 0H16.1C16.71 0 17.295 0.242321 17.7263 0.673654C18.1577 1.10499 18.4 1.69 18.4 2.3V16.1ZM8.05 13.8L16.1 5.75L14.4785 4.1285L8.05 10.5455L4.4965 7.0035L2.875 8.625L8.05 13.8Z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkmark.18842fd42d88c12902e3749bf869efed.svg";